/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentFoldersResponseData,
  GetDocumentFoldersResponseDataFromJSON,
  GetDocumentFoldersResponseDataFromJSONTyped,
  GetDocumentFoldersResponseDataToJSON
} from './GetDocumentFoldersResponseData'

/**
 *
 * @export
 * @interface GetDocumentFoldersResponse
 */
export interface GetDocumentFoldersResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentFoldersResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentFoldersResponseData}
   * @memberof GetDocumentFoldersResponse
   */
  data?: GetDocumentFoldersResponseData
}

export function GetDocumentFoldersResponseFromJSON(json: any): GetDocumentFoldersResponse {
  return GetDocumentFoldersResponseFromJSONTyped(json, false)
}

export function GetDocumentFoldersResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentFoldersResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentFoldersResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentFoldersResponseToJSON(value?: GetDocumentFoldersResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentFoldersResponseDataToJSON(value.data)
  }
}
